module.exports = __webpack_public_path__ + "img/logo.0016721f.png";